import { Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import ShieldIcon from 'assets/icons/shield_outline_white.svg';
import BackButton from 'components/BackButton/BackButton';
import { content } from './route.content';

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge',
)({
  component: WithdrawCryptoDisclaimer,
});

function WithdrawCryptoDisclaimer() {
  const navigate = useNavigate();
  const { productCode } = Route.useParams();
  const localizedContent = useContent(content);

  return (
    <div className="h-full py-4 px-4 md:px-8">
      <BackButton
        className={
          'w-full text-left lg:bg-body-background mt-1 ml-0 pl-6 lg:-mt-4 pt-2 lg:ml-0 lg:pl-0 lg:pt-0'
        }
      />
      <div className="w-full items-center flex flex-col mb-[80px]">
        <div className="flex flex-col items-center mt-4 lg:mt-14 gap-4 max-w-[600px] w-full">
          <img src={ShieldIcon} alt="Exclamation Icon" className="w-24" />
          <Heading level={1} className="mb-4">
            {localizedContent.title}
          </Heading>
          <div className="flex flex-col items-center gap-6 w-full">
            <div className="flex flex-col rounded-xl bg-background p-8 gap-4 w-full">
              <div className="space-y-6">
                <div>
                  <Typography
                    size="large"
                    className="text-neutral-300 mb-2 text-center sm:text-left w-full">
                    {localizedContent.description}
                  </Typography>
                </div>

                <div>
                  <Typography
                    size="large"
                    className="text-neutral-300 font-semibold text-center sm:text-left w-full">
                    {localizedContent.tipTitle}
                  </Typography>
                  <Typography
                    size="large"
                    className="text-neutral-300 mb-2 text-center sm:text-left w-full">
                    {localizedContent.tipDescription}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="pb-20 w-full">
              <Button
                size="large"
                color="primary"
                onPress={() =>
                  navigate({
                    to: `/funds/withdraw/crypto/${productCode}/disclaimer/accept`,
                  })
                }
                text={localizedContent.continue}
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
